import React from 'react';
import { SubHeading } from '../../components/SubHeading/SubHeading';
import { find } from '../../constants/images';


export const FindUs = () => (
  <div className="app__bg app__wrapper section__padding" id="contact">
    <div className="app__wrapper_info">
      <SubHeading title="Contact" />
      <h1 className="headtext__cormorant" style={{ marginBottom: '3rem' }}>Find Us</h1>
      <div className="app__wrapper-content">
        <p className="p__opensans"> Rm 34 Buffallo Mall, Naivasha-Nakuru Exit junction, Naivasha Town</p>
        <p className="p__cormorant" style={{ color: '#DCCA87', margin: '2rem 0' }}>Opening Hours</p>
        <p className="p__opensans">Mon - Fri: 7:00 am - 06:00 pm</p>
        <p className="p__opensans">Sat - Sun: 08:00 am - 07:00 pm</p>
        <p className="p__opensans">Our Call Center is ALWAYS OPEN, 24/7</p>
      </div>
      <button type="button" className="custom__button" style={{ marginTop: '2rem' }}>Visit Us</button>
    </div>

    <div className="app__wrapper_img">
      <img src={find} alt="finus_img" />
    </div>
  </div>
);

// export default FindUs;
